/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

import * as actions from '@tunnel-enums/index';
import {CombinesObjectModels} from '@tunnel-models/index';
import * as actionsTypesFromStore from '@tunnel-store/index';
import {Reducer} from 'redux';

/**
 * @function CameraSwitchSegmentedResetReducer
 * @param { any } sate: L'etat de l'application
 * @param {  actionsTypesFromStore.TypeCameraSwitchSegmentedResetAction }
 *     action: action de l'application
 * @return { Reducer }
 */
export const CameraSwitchSegmentedResetReducer: Reducer<
    CombinesObjectModels<any>> =
    (state: any = {

     }, action: actionsTypesFromStore.TypeCameraSwitchSegmentedResetAction) => {
      switch (action.type) {
        case actions.CameraSwitchSegmentedResetActionTypes
            .CAMERASWITCHSEGMENTEDRESET_INPROGRESS:

          return {
            loading: true, ...state
          }

          break;
        case actions.CameraSwitchSegmentedResetActionTypes
            .CAMERASWITCHSEGMENTEDRESET_FAIL:

          return {
            error: action.payload.error, loading: false,
          }

          break;

        case actions.CameraSwitchSegmentedResetActionTypes
            .CAMERASWITCHSEGMENTEDRESET_SUCCESS:

          return {
            data: action.payload.data, loading: false,
          }

          break;

        default:
          return state
          break;
      }
    }


// WEBPACK FOOTER //
// ./src/apps/tunnel/store/reducers/actions/camera/reset/index.ts